module.exports = __webpack_public_path__ + "img/Engine.c123875b.svg";